// extracted by mini-css-extract-plugin
export default {"container":"EmptyAndStartingPointProjects_container__TIK49","emptyProject":"EmptyAndStartingPointProjects_emptyProject__vWZHy"};